import React from 'react'
import {createSelector} from 'reselect'
import TasksApi from './Api/TasksApi'

export const getEmployeesList = createSelector(
    (state) => state.employees,
    (employees) => {
        return employees || []
    }
);
export const fetchEmployeesList = {
    fetchingApiFunc: TasksApi.getEmployees,
    selector: getEmployeesList,
    paramsFromProps: () => [],
    dataNamespace: 'employees'
}
